var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcadiaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300.17 368.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Element 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.24,336.19l17.94-45.37c-22.75,5-43.62,7.68-60.79,7.68q-5.22,0-9.85-.34L10.3,368h93.57A23.27,23.27,0,0,1,82.24,336.19ZM194.9,178.35h-6.85V229.6c31.61-14,52.6-28.32,63.29-38.91l-23.63-85.83L198.84,0h-87.2L82.77,104.86l-43.24,157a76.69,76.69,0,0,0,16.39,1.48c16.07,0,36.35-3,58.48-8.48l8-20.24V178.35h-6.84a8.43,8.43,0,0,1,0-16.86H194.9a8.43,8.43,0,1,1,0,16.86ZM147.49,95.47a13.84,13.84,0,1,1,13.84-13.84A13.84,13.84,0,0,1,147.49,95.47Zm21.48,40a7.64,7.64,0,1,1,7.64-7.64A7.64,7.64,0,0,1,169,135.5ZM206.6,368h93.57L260.75,224.85c-.57.4-1.15.81-1.74,1.21-16.6,11.4-37.67,22.69-61.34,33l.36.9,30.21,76.27A23.27,23.27,0,0,1,206.6,368Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.66,278c7.53,21.59,77.82,16.7,157-10.93S294.91,199.59,287.38,178c-3-8.59-15.89-13-35.31-13.43,7.53,1.82,12.46,5,14.05,9.56,6.39,18.31-42.84,52.13-110,75.54S29.48,277.24,23.09,258.93c-2.51-7.19,3.59-16.81,16-27.23C11.74,249.28-3.42,266.34.66,278Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcadiaIcon);
export default __webpack_public_path__ + "static/media/arcadia_icon.670dc271674226c8a056627d5bd09bf9.svg";
export { ForwardRef as ReactComponent };